module.exports = __webpack_public_path__ + "static/media/r8.24e5f92e.jpg";